
import React from 'react';
import GridTable from '../../components/GridTable';
import Layout from '../../components/Layout';
import { MODULES } from '../../utils/constants';
import AddSlotsDialog from './AddSlotsDialog';
import { getColumns } from './constants';
import { useSlotStore } from '../../services/slots';
import { useAppContext } from '../../services/context/AppContext';
import { getUserSpecialistId, isDoctorUser } from '../../utils/helper';

const Slots = () => {
    const {
        data,
        totalPages,
        currentPage,
        total,
        limit,
        isLoading,
        fetchGrid,
        onPageChange,
        onDelete,
        onDeleteSelf,
        setFilters
    } = useSlotStore();
    const { userData } = useAppContext();
    const isDoctor = isDoctorUser(userData);
    const specialistId = getUserSpecialistId(userData);


    React.useEffect(() => {
        if (isDoctor && specialistId) {
            setFilters({
                specialistId,
                slotType: 'consultation',
            });
            return;
        }

        fetchGrid();
    }, [fetchGrid, isDoctor, setFilters, specialistId]);

    return (
        <Layout appBarTitle="Slots Management">
            <Layout.Header component={AddSlotsDialog} props={{ module: MODULES.SLOTS }} />
            <Layout.Body
                component={GridTable}
                props={{
                    data,
                    columns: getColumns(currentPage, limit),
                    currentPage,
                    totalPages,
                    total,
                    loading: isLoading,
                    onPageChange,
                    module: MODULES.SLOTS,
                    onDelete: (item: any) => isDoctor ? onDeleteSelf(item._id) : onDelete(item._id),
                    rows: limit
                }}
            />
        </Layout>
    );
};

export default Slots;
